import $ from 'jquery';

// Functions
function hoverHandler(e) {
    // Define elements
    const dropdown = $(e.delegateTarget);
    const list = $(dropdown).children("ul");
    // Slide dropdown-list up and down
    $(list).slideToggle(100);
}

function mobileDropdown(e) {
    // Define elements
    const btn = $(e.delegateTarget);
    const list = $(btn).siblings()[0];
    // Add height of dropdown-list to height of nav
    if ($(list).css('display') == 'none') {
        $("nav").animate({
            height: "+=" + $(list).children("li").length * 36
        });
    } else {
        $("nav").animate({
            height: "-=" + $(list).children("li").length * 36
        }, () => $("nav").css('height', ''));
    }
    // Slide dropdown-list up and down
    $(list).slideToggle();
    // Rotate arrow in dropdown-btn
    $($(btn).find("svg")).toggleClass("up");
}

export { hoverHandler, mobileDropdown };
